<template>
  <v-card flat class="presence-btn">
    <v-menu ref="menu" open-on-hover bottom offset-y>
      <template v-slot:activator="{ on }">
        <v-list-item v-on="on" dense class="px-1" style="cursor:pointer">
          <v-list-item-content class="justify-end">{{ $t(textKey) }}</v-list-item-content>
          <v-list-item-icon>
            <v-icon :color="color">{{ icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </template>
      <v-list nav dense>
        <v-text-field dense
          v-model="customText"
          :color="customColorSaved"
          clearable
          append-outer-icon="mdi-send"
          @click:append-outer="updateCustom"
          @click:clear="clearCustom"
          @click.stop
          @keyup.enter="updateCustom"
          placeholder="Custom"
        />
        <v-list-item v-for="(status) in statuses" :key="status.status" :input-value="currentPresence.status === status.status" @click="update(status)">
          <v-list-item-content class="justify-end">{{ $t(chatStatusTextKey(status)) }}</v-list-item-content>
          <v-list-item-icon>
            <v-icon :color="chatStatusColor(status)">{{ chatStatusIcon(status) }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChatPresence from 'Store/class/chat/presence'

export default {
  name: 'chatpresence',
  data () {
    return {
      customText: ''
    }
  },
  mounted () {
    this.customText = this.currentPresence.statusText
  },
  computed: {
    ...mapGetters({
      chatUser: 'chat/authenticatedRocketChatUser',
      presences: 'chat/presences',
      presenceTypes: 'chat/presenceTypes'
    }),
    presence () {
      const presence = this.presences.find(current => current.userId === this.chatUser?.username) ?? { status: 'offline', statusText: null }
      return presence
    },
    currentPresence: {
      get: function () {
        return { status: this.presence.status, statusText: this.presence.statusText }
      },
      set: function (value) {
        this.setPresence({ userId: this.chatUser?.username, status: value.status, statusText: value.statusText })
      }
    },
    statuses () {
      return this.presenceTypes
    },
    textKey () {
      return this.chatStatusTextKey(this.presence)
    },
    icon () {
      return this.chatStatusIcon(this.presence)
    },
    color () {
      return this.chatStatusColor(this.presence)
    },
    customColorSaved () {
      return this.customText === this.currentPresence.statusText ? 'green' : 'gray'
    }
  },
  methods: {
    ...mapActions({
      setPresence: 'chat/setPresence',
      updatePresence: 'chat/updatePresence'
    }),
    update: function (status) {
      this.currentPresence = { status: status.status, statusText: this.customText }
    },
    updateCustom: function () {
      this.currentPresence = { status: this.presence.status, statusText: this.customText }
      this.$refs.menu.save()
    },
    clearCustom: function () {
      this.customText = ''
      this.updateCustom()
    },
    chatStatusIcon: function (status) {
      return ChatPresence.statusIcon(status)
    },
    chatStatusColor: function (status) {
      return ChatPresence.statusColor(status)
    },
    chatStatusTextKey: function (status) {
      return ChatPresence.statusTextKey(status)
    }
  }
}
</script>
